import { Place, PlaceGeocoding } from '../models/shared/Place';

export interface GeolocationError {
    code: number;
    message: string;
}

export const getCurrentLocation = (): Promise<PlaceGeocoding> => {
    return new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
            reject({
                code: -1,
                message: 'Geolocation is not supported by this browser.'
            });
            return;
        }

        const options: PositionOptions = {
            enableHighAccuracy: true,
            timeout: 100000,
            maximumAge: 300000 // 5 minutes
        };

        navigator.geolocation.getCurrentPosition(
            (position) => {
                resolve({
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                });
            },
            (error) => {
                let message: string;
                switch (error.code) {
                    case error.PERMISSION_DENIED:
                        message = 'Location permission denied';
                        break;
                    case error.POSITION_UNAVAILABLE:
                        message = 'Location information is unavailable';
                        break;
                    case error.TIMEOUT:
                        message = 'Location request timed out';
                        break;
                    default:
                        message = 'An unknown error occurred while retrieving location';
                        break;
                }
                reject({
                    code: error.code,
                    message
                });
            },
            options
        );
    });
};

export const geocodingToPlace = (geocoding: PlaceGeocoding): Place => {
    return {
        placeId: `geocoding_${geocoding.lat}_${geocoding.lng}`,
        name: `${geocoding.lat.toFixed(4)}, ${geocoding.lng.toFixed(4)}`,
        formattedAddress: `${geocoding.lat.toFixed(6)}, ${geocoding.lng.toFixed(6)}`,
        geocoding,
        isGeocodingOnly: true,
    };
}

